module.exports = __webpack_public_path__ + "video/1300_KBSAT30_2022_SERFConclusion.b07e9c40.vtt";